import {
	formatPhoneNumber,
	getAttributeOrThrow,
	getOrUndefined,
	qsRequired,
} from '../core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class KlaviyoEmail extends UcoastEl {
	static htmlSelector = 'klaviyo-email'
	form: HTMLFormElement
	list: string
	segment_key: string
	submitButton: HTMLButtonElement
	emailInput: HTMLInputElement
	successMessage: string
	route: string
	companyId: string

	constructor() {
		super()
		this.form = qsRequired('form', this)
		this.list = getAttributeOrThrow('data-list-id', this.form)
		this.segment_key = getAttributeOrThrow('data-segment-key', this.form)
		this.submitButton = qsRequired('[type="submit"]', this)
		this.emailInput = qsRequired('[type="email"]', this)
		this.successMessage = getAttributeOrThrow('data-success', this.form)
		this.companyId = getAttributeOrThrow('data-company-id', this)
		this.route = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`
		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
	}

	addToKlaviyoListConfig(body: FormData) {
		const values = {
			email: this.emailInput.value,
			list_id: this.list,
			phone_number: getOrUndefined(body, 'phone_number'),
			language_iso: getOrUndefined(body, 'language_iso') ?? 'en',
			market_handle: getOrUndefined(body, 'market_handle') ?? 'us'
		}
		if (values.phone_number) {
			values.phone_number = formatPhoneNumber(values.phone_number)
		}
		const data ={
			data: {
				type: "subscription",
				attributes: {
					custom_source: this.segment_key,
					profile: {
						data: {
							type: "profile",
							attributes: {
								email: values.email,
								phone_number: values.phone_number,
								properties: {
									language_iso: values.language_iso,
									market_handle: values.market_handle,
								}
							},
						}
					}
				},
				relationships: {
					list: {
						data: {
							type: "list",
							id: values.list_id
						}
					}
				}
			}
		}
		const timestamp = new Date()
		// @ts-ignore
		data.data.attributes.profile.data.attributes.properties[this.segment_key] = timestamp.toISOString();
		return {
			method: 'POST',
			mode: 'cors' as RequestMode,
			headers: {
				'Content-Type': 'application/json',
				'Revision': '2024-05-15'
			},
			body: JSON.stringify(data),
		}
	}

	onSubmitHandler(evt: Event) {
		evt.preventDefault()
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return
		if (this.emailInput.value.length < 1) return

		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.classList.add('loading')

		const formData = new FormData(this.form)

		const config = this.addToKlaviyoListConfig(formData)

		fetch(this.route, config)
			.then((response) => {
				return response.text()
			})
			.then((response) => {
				this.emailInput.value = ''
				if (response) {
					this.emailInput.placeholder =
						'This email address is invalid.'
				} else {
					this.emailInput.placeholder = this.successMessage
				}
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				this.submitButton.classList.remove('loading')
				this.submitButton.removeAttribute('aria-disabled')
			})
	}
}
